import { immerable } from "immer";
import { DbMongoSerializationBaseInfos } from "./db-mongo-serialization-base-infos";

import { PlatformAlertSeverity } from "./platform-alert-severity";

export class DbPlatformAlertInfos extends DbMongoSerializationBaseInfos {
  [immerable] = true;
  platformId: number | null = 0;
  userId: number | null = 0;
  creationDate: Date | null = null;
  startDate: Date | null = null;
  endDate: Date | null = null;
  severity: PlatformAlertSeverity | null = null;
  subject: string | null = null;
  message: string | null = null;
  isActive: boolean | null = null;
  userName: string | null = null;

  constructor(init?: Partial<DbPlatformAlertInfos>) {
    super();
    Object.assign(this, init);
  }
}
